import React, { useEffect, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import filterM from "../../../assets/nav-icon/filter-m.svg";
import FNBICON from "../../../assets/nav-icon/fnb-home-icon.svg";
import FilterBlack from "../../../assets/static-page/filter-black.svg";
import arrowUp from "../../../assets/brand/filter-icon.svg";
import arrowDown from "../../../assets/brand/arrow_down.svg";
import home from "../../../assets/brand/Home_grey.png";
import HomeBlack from "../../../assets/brand/Home_black1.png";
import { useNavigate } from "react-router-dom";
import cinemas from "../../../assets/brand/cinema.svg";
import CinemasBlack from "../../../assets/brand/Cinemas_black.png";
import star from "../../../assets/brand/star.svg";
import StartBlack from "../../../assets/brand/star_black.png";
import OfferStroke from "../../../assets/brand/offerStroke.svg";
import OfferBlack from "../../../assets/brand/offerblack.svg";
import comingsoon from "../../../assets/brand/movie.svg";
import Comingsoon_black from "../../../assets/brand/coming_soon_black.png";
import more from "../../../assets/brand/more.svg";
import InvestorBlack from "../../../assets/nav-icon/investor-black.svg";
import promoteEarn from "../../../assets/nav-icon/Promote.svg";
import Screenit_icon from "../../../assets/nav-icon/screenit_logo.png";
import filmFestival from "../../../assets/nav-icon/CuratedShows.svg";
import ODRBlack from "../../../assets/nav-icon/odr-black.svg";
import "./mobilefooter.css";
import { DarkButton, LightButton } from "src/styled-components/customButtons";
import giftCardIcon from "../../../assets/dropdowIcon/card_giftcard.svg";
import kotak from "../../../assets/dropdowIcon/koktacredit.svg";
import advertiseIcon from "../../../assets/dropdowIcon/newspaper_black.svg";
import Honk from "../../../assets/ads-screen/honk-icon.svg";
import pristineIcon from "../../../assets/dropdowIcon/auto_awesome.svg";
import pvrcareIcon from "../../../assets/dropdowIcon/care.svg";
import merchandiseIcon from "../../../assets/dropdowIcon/local_mall_black.svg";
import movieOnDemand from "../../../assets/dropdowIcon/theaters_black.svg";
import { setMobileFilterValues } from "../../../redux/actions/mobileFilterAction";
import { useDispatch, useSelector } from "react-redux";
import { setLoginViewMode } from "src/redux/actions/loginViewAction";
import * as appConstants from "../../../constants/index";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import Login from "src/views/common/login/Login";
import { getSplashData } from "src/services/OtherServices";
import MoreDropdown from "src/views/common/navbar/more-dropdown/MoreDropdown";
import homeIcon from "../../../assets/mobile-footer-icon/home.svg";
import homeActiveIcon from "../../../assets/mobile-footer-icon/home-active.svg";
import cinemIcon from "../../../assets/mobile-footer-icon/cinema_icon.svg";
import cinemaInoxActiveIcon from "../../../assets/mobile-footer-icon/inoxActive.svg";
import cinemaPvrActiveIcon from "../../../assets/mobile-footer-icon/cinemaActive.svg";
import comingSoonIcon from "../../../assets/mobile-footer-icon/comingsoon.svg";
import comingSoonActiveIcon from "../../../assets/mobile-footer-icon/comingsoon-active.svg";
import passportIcon from "../../../assets/mobile-footer-icon/passport.svg";
import passportActiveIcon from "../../../assets/mobile-footer-icon/passport-active.svg";
import moreIcon from "../../../assets/mobile-footer-icon/more.svg";
import { InputText } from "primereact/inputtext";
import OTPInput from "react-otp-input";
import { ProceedButton } from "src/styled-components/generalTags";
import ConfirmMessageDialog from "src/global-functions/ConfirmMessageDialog";
import cinemaHouse from "../../../assets/comingsoon/Cinema House 1.gif";
import OtpInput from "react-otp-input";

const LoginPopup = ({ isOpen, onClose, theme, spalshData }) => {
  const navigate = useNavigate();
  const [userNumber, setUserNumber] = useState("");
  const [userCompany, setUserCompany] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userLocation, setUserLocation] = useState("");
  const [errors, setErrors] = useState({});
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState(null);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  if (!isOpen) return null;



  // 🔐 Generate hash (same as Swift)
  async function generateHashText(mobile, platform) {
    const secretKey = "tdy*gdr?diu(grui^j9utyf";
    const timestamp = Date.now();
    const hashText = `|${mobile}|${timestamp}|${secretKey}|${mobile.substring(
      0,
      6
    )}|${platform}|`;

    const encoder = new TextEncoder();
    const data = encoder.encode(hashText);
    const hashBuffer = await crypto.subtle.digest("SHA-512", data);
    const hashArray = new Uint8Array(hashBuffer);
    const hashBase64 = btoa(String.fromCharCode(...hashArray));

    return { hash: hashBase64, timestamp };
  }

  // 📲 Request OTP
  const handleLogin = async () => {
    let newErrors = {};

    if (!userNumber) {
      newErrors.userNumber = "Phone number is required";
    } else if (!/^[0-9]{10}$/.test(userNumber)) {
      newErrors.userNumber = "Enter a valid 10-digit phone number";
    }

    if (!userCompany) {
      newErrors.userCompany = "Organisation name is required";
    }

    if (!userEmail) {
      newErrors.userEmail = "Email is required";
    }

    if (!userLocation) {
      newErrors.userLocation = "Location is required";
    }


    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    try {
      setLoading(true);
      const { hash, timestamp } = await generateHashText(userNumber, "LOGIN");

      const postData = {
        mobile: userNumber,
        orgName: userCompany,
        email: userEmail,
        location: userLocation,
        token: hash,
        timestamp: timestamp,
      };

      const response = await axios.post(
        `${appConstants.base_url}v1/adsales/request-otp`,
        postData,
        {
          headers: {
            chain: theme === "inoxTheme" ? "INOX" : "PVR",
            city: localStorage.getItem("city"),
            appVersion: appConstants.av,
            platform: appConstants.pt,
            country: appConstants.cname,
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("API Response-----", response.data);

      if (
        response.data?.code === 10001 &&
        response.data?.result === "success"
      ) {
        const leadId = response.data?.output?.leadId || 0;
        // swal("Success", "OTP sent successfully!", "success");
        localStorage.setItem("leadId", leadId);
        setShowOtpPopup(true);
      } else {
        swal("Error", response.data?.msg || "Something went wrong", "error");
      }
    } catch (error) {
      console.error(error);
      swal("Error", "Failed to request OTP. Try again later.", "error");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Verify OTP
  const handleVerifyOtp = async () => {
    try {
      if (!otp || otp.length < 6) {
        swal("Error", "Please enter a valid 6-digit OTP", "error");
        return;
      }

      setLoading(true);
      const leadId = localStorage.getItem("leadId");

      const verifyData = {
        otp: otp,
        leadId: leadId,
      };

      const response = await axios.post(
        `${appConstants.base_url}v1/adsales/verify-otp`,
        verifyData,
        {
          headers: {
            chain: theme === "inoxTheme" ? "INOX" : "PVR",
            city: localStorage.getItem("city"),
            appVersion: appConstants.av,
            platform: appConstants.pt,
            country: appConstants.cname,
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("Verify OTP Response::::::", response.data);

      if (
        response.data?.code === 10001 &&
        response.data?.result === "success"
      ) {
        navigate("/ads-campaigns");
        setShowOtpPopup(false);
        onClose();
        localStorage.setItem("calenderurl", response.data?.output?.calenderurl)
        localStorage.setItem("ratecardurl", response.data?.output?.ratecardurl)
        localStorage.setItem("onfscreenTnc", response.data?.output?.onfscreenTnc)
        localStorage.setItem("offscreenTnc", response.data?.output?.offscreenTnc)
      }
      // 🔴 Special Case: 12002 → show error dialog
      else if (response.data?.code === 12002) {
        setErrorMsg(response.data);  // ✅ store error response here
        setShowErrorAlert(true);
      }
      else {
        setErrorMsg(response.data);  // ✅ catch other errors too
        setShowErrorAlert(true);
      }
    } catch (error) {
      console.error(error);
      swal("Error", "Failed to verify OTP. Try again later.", "error");
    } finally {
      setLoading(false);
    }
  };



  const handleCloseBtn = () => {
    setUserNumber("");
    setUserCompany("");
    setErrors({});
    setOtp("");
    onClose();
  };

  return (
    <div className="login-popup-overlay">
      {!showOtpPopup ? (
        <div className="organisation-box">
          <div className="cross-icon mx-2" style={{ marginRight: "-14px" }}>
            <span onClick={handleCloseBtn}>
              <i className="pi pi-times"></i>
            </span>
          </div>

          <h5>Verify Phone Number & Organisation</h5>
          <p>
            Please enter the name of the organization for <br />
            which you’d like to run the Ad.
          </p>

          {/* Phone Number */}
          <div className="mobile">
            <span className="p-float-label">
              <InputText
                id="Phone Number"
                style={{ height: "50px" }}
                value={userNumber}
                maxLength={10}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 10) {
                    setUserNumber(value);
                  }
                }}
              />
              <label htmlFor="Phone Number">Phone</label>
            </span>
            {errors.userNumber && (
              <small style={{ color: "red" }}>{errors.userNumber}</small>
            )}
          </div>

          {/* Organisation */}
          <div className="mobile">
            <span className="p-float-label">
              <InputText
                id="Organisation Name"
                style={{ height: "50px" }}
                value={userCompany}
                onChange={(e) => setUserCompany(e.target.value)}
              />
              <label htmlFor="Organisation Name">Organisation Name</label>
            </span>
            {errors.userCompany && (
              <small style={{ color: "red" }}>{errors.userCompany}</small>
            )}
          </div>


          {/* eamil */}
          <div className="mobile">
            <span className="p-float-label">
              <InputText
                id="email"
                style={{ height: "50px" }}
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
              />
              <label htmlFor="email">email</label>
            </span>
            {errors.userEmail && (
              <small style={{ color: "red" }}>{errors.userEmail}</small>
            )}
          </div>



          {/* Organisation */}
          <div className="mobile">
            <span className="p-float-label">
              <InputText
                id="Location"
                style={{ height: "50px" }}
                value={userLocation}
                onChange={(e) => setUserLocation(e.target.value)}
              />
              <label htmlFor="Location">Location</label>
            </span>
            {errors.userLocation && (
              <small style={{ color: "red" }}>{errors.userLocation}</small>
            )}
          </div>

          {/* Proceed */}
          <ProceedButton className="btn-proceeds mobile-ads-proce" onClick={handleLogin}>
            Proceed{" "}
            {loading && (
              <i
                className="pi pi-spin pi-spinner"
                style={{ fontSize: "1.2em" }}
              ></i>
            )}
          </ProceedButton>
        </div>
      ) : (
        // 🔑 OTP Screen
        <div className="email-otp-modal-overlay">
          <div className="email-otp-modal">
            <div className="cross-icon mx-2">
              <span onClick={handleCloseBtn}>
                <i className="pi pi-times"></i>
              </span>
            </div>

            <div className="cinema-house mobile-login-M Register-modal-desk register-track">
              <img
                src={cinemaHouse}
                alt=""
                className="img-fluid register-otp desktop-login-icon"
              />
              {spalshData && (
                <img
                  src={
                    spalshData?.logo || (theme === "inoxTheme" ? inoxM : pvrM)
                  }
                  alt=""
                  className="img-fluid mobile-login-icon"
                />
              )}

              <h1 className="desktop-view-login-head">Verify OTP</h1>
              <h1 className="Mobile-view-login-head">
                Verify
                <br /> OTP Code
              </h1>

              {/* 📲 Show Phone Number with Edit Option */}
              <p className="otp-content desktop-view-login-content">
                We've sent a code to <b>{userNumber}</b>
                <span
                  style={{ color: "#007bff", cursor: "pointer", marginLeft: "8px" }}
                  onClick={() => setShowOtpPopup(false)} // 👈 go back to edit
                >
                  Edit
                </span>
              </p>
              <p className="Mobile-view-login-content">
                We've sent a code to <b>{userNumber}</b>
                <span
                  style={{ color: "#000", cursor: "pointer", marginLeft: "8px" }}
                  onClick={() => setShowOtpPopup(false)}
                >
                  Edit
                </span>
              </p>

              {/* OTP Input */}
              <div className="otp-feild">
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  inputType="tel"
                  numInputs={6}
                  inputStyle={{ width: "60px" }}
                  className="otp-box"
                  isInputNum={true}
                  shouldAutoFocus={true}
                  renderInput={(props, index) => (
                    <input {...props} className="otpfeild" />
                  )}
                />
              </div>
              <div className="otp-phone-info" style={{ marginBottom: "15px" }}>
                <p style={{ fontWeight: "bold", textAlign: "center" }}>
                  <button
                    style={{
                      border: "none",
                      background: "transparent",
                      color: "#000",
                      cursor: "pointer",
                      textDecoration: "underline",
                      marginLeft: "10px",
                      fontSize: "14px",

                    }}
                    onClick={() => handleLogin()} // go back to phone screen
                  >
                    Re-Send OTP
                  </button>
                </p>
              </div>

              {/* Verify OTP Button */}
              <ProceedButton
                className="btn-proceeds mobile-ads-proce"
                onClick={handleVerifyOtp}
              >
                Verify OTP{" "}
                {loading && (
                  <i
                    className="pi pi-spin pi-spinner"
                    style={{ fontSize: "1.2em" }}
                  ></i>
                )}
              </ProceedButton>

              {/* <div className="resend-otp"></div> */}
            </div>
          </div>
        </div>
        // <div className="email-otp-modal-overlay">
        //   <div className="email-otp-modal">
        //     <div className="cross-icon mx-2">
        //       <span onClick={handleCloseBtn}>
        //         <i className="pi pi-times"></i>
        //       </span>
        //     </div>

        //     <div className="cinema-house mobile-login-M Register-modal-desk register-track">
        //       <img
        //         src={cinemaHouse}
        //         alt=""
        //         className="img-fluid register-otp desktop-login-icon"
        //       />
        //       {spalshData && (
        //         <img
        //           src={
        //             spalshData?.logo || (theme === "inoxTheme" ? inoxM : pvrM)
        //           }
        //           alt=""
        //           className="img-fluid mobile-login-icon"
        //         />
        //       )}

        //       <h1 className="desktop-view-login-head">Verify OTP</h1>
        //       <h1 className="Mobile-view-login-head">
        //         Verify
        //         <br /> OTP Code
        //       </h1>

        //       <p className="otp-content desktop-view-login-content">
        //         We've sent a code to your mobile number
        //       </p>
        //       <p className="Mobile-view-login-content">
        //         We've sent a code to your mobile number
        //       </p>


        //       <div className="otp-feild">
        //         <OtpInput
        //           value={otp}
        //           onChange={setOtp}
        //           inputType="tel"
        //           numInputs={6}
        //           inputStyle={{ width: "60px" }}
        //           className="otp-box"
        //           isInputNum={true}
        //           shouldAutoFocus={true}
        //           renderInput={(props, index) => (
        //             <input {...props} className="otpfeild" />
        //           )}
        //         />
        //       </div>


        //       <ProceedButton className="btn-proceeds mobile-ads-proce" onClick={handleVerifyOtp}>
        //         Verify OTP{" "}
        //         {loading && (
        //           <i
        //             className="pi pi-spin pi-spinner"
        //             style={{ fontSize: "1.2em" }}
        //           ></i>
        //         )}
        //       </ProceedButton>

        //       <div className="resend-otp"></div>
        //     </div>
        //   </div>
        // </div>
      )}
      <ConfirmMessageDialog
        icon={"error"}
        visible={showErrorAlert}
        className="fail-msg-show"
        onHide={() => setShowErrorAlert(false)}
        title={errorMsg?.result}   // 🔄 changed from successMsg
        message={errorMsg?.msg}    // ✅ now works
        showConfirmButton={true}
        timer={2000}
        showCloseIcon={false}
      />

    </div>
  );
};

const MobileFooter = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = localStorage.getItem("theme");
  const [visibleBottom, setVisibleBottom] = useState(false);
  const currentPath = window.location.pathname.split("/");
  const [showLanguage, setShowLanguage] = useState(true);
  const [showGenre, setShowGenre] = useState(false);
  const [showAccessiblity, setShowAccessiblity] = useState(true);
  const [selectedLanguageIds, setSelectedLanguageIds] = useState([]);
  const [selectedGenreIds, setSelectedGenreIds] = useState([]);
  const [selectedAccessiblityId, setSelectedAccessiblityId] = useState(false);
  const [filterUIViewMode, setFilterUIViewMode] = useState(0);
  const loginInfo = JSON.parse(sessionStorage.getItem("loginInfo") || "null");
  const [spalshData, setSpalshData] = useState(null);
  const loginVewMode = useSelector((state) => state.loginViewMode.value);
  const countForSearch = useSelector(
    (state) => state?.mobileFilterReduce.status
  );
  const filterLanguage = JSON.parse(localStorage.getItem("m-filter-lng"));
  const filterGeners = JSON.parse(localStorage.getItem("m-filter-grs"));
  const SeeallMoviesdata = JSON.parse(localStorage.getItem("filtermobileNowshowing"));
  const [totalMovieCount, setTotalMovieCount] = useState('');
  const filterDataVal = useSelector((state) => state.mobileFilterReduce);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);
  const [isLoginPopupOpen, setIsLoginPopupOpen] = useState(false);

  const hitGaTag = (event, var_more_buttons) => {
    let dataLayer = window["dataLayer"] || [];
    dataLayer.push({
      event: event,
      var_more_buttons: var_more_buttons,
    });
  };

  const hitGaTags = (event, var_more_buttons) => {
    let dataLayer = window["dataLayer"] || [];
    dataLayer.push({
      event: event,
      var_bottom_navi: var_more_buttons,
    });
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 575);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {

  }, [visibleBottom, filterDataVal]);

  useEffect(() => {
    const count = getFilteredMovieCount();
    setTotalMovieCount(count);

  }, [selectedLanguageIds, selectedGenreIds, selectedAccessiblityId]);

  const getFilteredMovieCount = () => {
    if (!SeeallMoviesdata || !Array.isArray(SeeallMoviesdata)) return null;

    const isAnyFilterApplied =
      selectedLanguageIds.length > 0 ||
      selectedGenreIds.length > 0 ||
      !!selectedAccessiblityId;

    if (!isAnyFilterApplied) return null;

    const count = SeeallMoviesdata.filter((item) => {
      const lngMatch =
        selectedLanguageIds.length > 0
          ? selectedLanguageIds.some((lang) => item.mfs?.includes(lang))
          : true;

      const grsMatch =
        selectedGenreIds.length > 0
          ? selectedGenreIds.some((genre) => item.grs?.includes(genre))
          : true;

      const accessiblityMatch = selectedAccessiblityId
        ? item.subtitleBln === selectedAccessiblityId
        : true;

      return lngMatch && grsMatch && accessiblityMatch;
    }).length;

    return count;
  };

  const activeCurrentPathVal =
    currentPath[1] === ""
      ? 0
      : currentPath[1] === "cinemas"
        ? 1
        : currentPath[1] === "mobile-map"
          ? 1
          : currentPath[1] === "offers"
            ? 2
            : currentPath[1] === "coming-soon"
              ? 3
              : currentPath[1] === "see-all"
                ? 9
                : 4;

  const [viewMode, setViewMode] = useState(activeCurrentPathVal);

  const accessiblityList = ["Subtitle"];

  useEffect(() => {
    profileRequest();
  }, [localStorage.getItem("city")]);

  const findActiveLanguageFilter = (lngId) => {
    const isPresent = selectedLanguageIds.some((x) => x === lngId);
    if (isPresent) {
      const filterId = selectedLanguageIds.filter((item) => {
        return item !== lngId;
      });
      setSelectedLanguageIds([...filterId]);
    } else {
      setSelectedLanguageIds([lngId, ...selectedLanguageIds]);
    }
  };

  const findActiveGenreFilter = (lngId) => {
    const isPresent = selectedGenreIds.some((x) => x === lngId);
    if (isPresent) {
      const filterId = selectedGenreIds.filter((item) => {
        return item !== lngId;
      });
      setSelectedGenreIds([...filterId]);
    } else {
      setSelectedGenreIds([lngId, ...selectedGenreIds]);
    }
  };

  const findActiveAccessiblityFilter = (lngId) => {
    setSelectedAccessiblityId(!selectedAccessiblityId);
  };



  const hitGa = (event) => {
    let dataLayer = window["dataLayer"] || [];
    dataLayer.push({
      event: event,
    });
  };
  const hitMoreGa = (click_text) => {
    let dataLayer = window["dataLayer"] || [];
    dataLayer.push({
      event: "top_navi_more_click",
      click_text: click_text,
    });
  };

  const profileRequest = async () => {
    getSplashData()
      .then((res) => {
        const dt = res.data;
        if (dt.result === "success") {
          setSpalshData(dt.output);
        } else {
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  const moreUI = () => {
    return (
      <>
        <div className="more-show-drawer">
          <ul>
            {spalshData?.pvrlive ? (
              <li
                className="more-item"
                onClick={() => {
                  hitMoreGa("Live Movies");
                  hitGaTag("more_buttons_click", spalshData?.pvrlive);
                  if (currentPath === "/live-movies") {
                    window.location.href = "/live-movies";
                  } else {
                    navigate("/live-movies"); 
                  }
                }}
              >
                <img src={filmFestival} alt="" className="mx-2"/>
                {spalshData?.pvrlive}
              </li>
            ) : (
              ""
            )}
            {/* <li
              className="more-item"
              onClick={() => {
                const currentPath = window.location.pathname;
                hitMoreGa("Gift Cards");

                if (currentPath === "/gift-cards") {
                  window.location.href = "/gift-cards";
                } else {
                  navigate("/gift-cards");
                }
              }}
            >
              <img src={giftCardIcon} alt="" className="mx-2" />
              Gift Card
            </li> */}
            {spalshData?.passport == "true" ? (
              <li
                className="more-item"
                onClick={() => {
                  setViewMode(2);
                  hitGa("top_navi_offers");
                  let dataLayer = window["dataLayer"] || [];
                  dataLayer.push({
                    event: "more_buttons_click",
                    var_more_buttons: "Offer"
                  })
                  const currentPath = window.location.pathname;
                  if (currentPath === "/offers") {
                    window.location.href = "/offers";
                  } else {
                    navigate("/offers"); // Use your navigation function here
                  }
                }}
              >
                <img
                  src={viewMode === 2 ? OfferBlack : OfferStroke}
                  alt=""
                  width={30}
                  className="mx-2"
                />
                Offer
              </li>
            ) : (
              // <li
              //   className="more-item"
              //   onClick={() => {
              //     // const currentPath = window.location.pathname;
              //     // if (currentPath === "/passport") {
              //     //   window.location.href = "/passport";
              //     // } else {
              //     //   if (loginInfo?.data?.mob) {
              //     //     navigate("/passport");
              //     //   } else {
              //     //     dispatch(setLoginViewMode({ value: true }));
              //     //   }
              //     // }
              //     window.open("https://passport.pvrinox.com/", '_blank').focus();
              //   }}
              // >
              //   <img src={StartBlack} alt="" width={20} className="mx-2" />
              //   Passport
              // </li>
              ""
            )}
            {/* <li
              className="more-item"
              onClick={() => {
                const currentPath = window.location.pathname;
                hitMoreGa("Advetise");
                hitGaTag("more_buttons_click", "Advetise");

                if (currentPath === "/advertise") {
                  window.location.href = "/advertise";
                } else {
                  navigate("/advertise"); // Use your navigation function here
                }
              }}
            >
              <img src={advertiseIcon} alt="" className="mx-2" />
              Advertise
            </li> */}
            {String(spalshData?.adsales).toLowerCase() === "true" && (
              <li
                className="more-item"
                onClick={() => {
                  hitMoreGa("Ads Campaigns");
                  hitGaTag("more_buttons_click", "Advertise with us");
                  setIsLoginPopupOpen(true);
                  setVisibleBottom(false);
                }}
              >
                <img src={Honk} alt="" className="mx-2" />
                Advertise with us
              </li>
            )}

            {/* <li
              className="more-item"
              onClick={() => {
                hitMoreGa("Merchandise");

                window.open(
                  theme === "inoxTheme"
                    ? "https://inox.macmerise.com/"
                    : "https://pvr.macmerise.com/?user_agent=pvr/",
                  "_blank"
                );
              }}
            >
              <img src={merchandiseIcon} alt="" className="mx-2" />
              Merchandise
            </li> */}
            <li
              className="more-item"
              onClick={() => {
                hitMoreGa("Investor Section");
                hitGaTag("more_buttons_click", "Investor Section");

                if (currentPath === "/investors-section") {
                  window.location.href = "/investors-section";
                } else {
                  navigate("/investors-section"); // Use your navigation function here
                }
              }}
            >
              <img src={InvestorBlack} alt="" className="mx-2" />
              Investor Section
            </li>
            <li
              className="more-item"
              onClick={() => {
                hitMoreGa("Merchandise");
                hitGaTag("more_buttons_click", "ODR Portal");

                window.open("https://smartodr.in/login", "_blank").focus();
              }}
            >
              <img src={ODRBlack} alt="" className="mx-2" />
              ODR Portal
            </li>
            {spalshData?.screenit_web === "true" && (
              <li
                className="more-item"
                onClick={() => {
                  hitGa("screenit_click");
                  hitGaTag("more_buttons_click", "ScreenIT");

                  if (currentPath === "/screenit") {
                    window.location.href = "/screenit";
                  } else {
                    navigate("/screenit"); // Use your navigation function here
                  }
                }}
              >
                <img src={Screenit_icon} alt="" className="mx-2" />
                ScreenIT
              </li>
            )}
            {/* <li
              className="more-item"
              onClick={() => {
                hitMoreGa("/promote-earnt");

                if (currentPath === "/promote-earn") {
                  window.location.href = "/promote-earn";
                } else {
                  navigate("/promote-earn");
                }
              }}
            >
              <img src={promoteEarn} alt="" className="mx-2" />
              Promote & Earn
            </li> */}

            <li>
              <div className="menu-divider"></div>
            </li>
            <li
              className="more-item mx-2"
              onClick={() => {
                hitMoreGa("Feedback");
                hitGa("feedback");
                hitGaTag("more_buttons_click", "Customer Experience");
                const currentPath = window.location.pathname;
                if (currentPath === "/feedback") {
                  window.location.href = "/feedback";
                } else {
                  navigate("/feedback");
                }
              }}
            >
              Customer Experience
            </li>
            {String(spalshData?.upi_mandate).toLowerCase() === "true" && (
              <li
                className="more-item mx-2"
                style={{ whiteSpace: "nowrap" }}
                onClick={() => {
                  hitMoreGa("UPI Mandate");
                  window.open("https://web.pvrinox.com/mandate", "_blank");
                  // Instead of navigating, open the login popup
                }}
              >
                UPI Reserve Pay
              </li>
            )}
            {theme === "inoxTheme" ? (
              ""
            ) : (

              <li
                className="more-item mx-2"
                onClick={() => {
                  hitMoreGa("Privilege Plus");
                  hitGaTag("more_buttons_click", "Privilege Plus");

                  const currentPath = window.location.pathname;
                  if (currentPath === "/kotak-pp-plus") {
                    window.location.href = "/kotak-pp-plus";
                  } else {
                    navigate("/kotak-pp-plus"); // Use your navigation function here
                  }
                }}
              >
                Privilege Plus
              </li>
            )}
            <li
              className="more-item mx-2"
              style={{ whiteSpace: "nowrap" }}
              onClick={() => {
                window.open("https://web.pvrinox.com/kotak-cards", "_blank");
                hitMoreGa("Kotak Cards");
                hitGaTag("more_buttons_click", "Kotak Cards");
              }}
            >
              PVR INOX Kotak Credit Card
            </li>


            <li
              className="more-item mx-2"
              onClick={() => {
                hitMoreGa("About us");
                hitGaTag("more_buttons_click", "About us");

                const currentPath = window.location.pathname;
                if (currentPath === "/about-us") {
                  window.location.href = "/about-us";
                } else {
                  navigate("/about-us");
                }
              }}
            >
              About us
            </li>
            <li
              className="more-item mx-2"
              onClick={() => {
                hitGa("experiences");
                hitMoreGa("experiences_view");
                hitGaTag("more_buttons_click", "Experiences");

                const currentPath = window.location.pathname;
                if (currentPath === "/cinema-format") {
                  window.location.href = "/cinema-format";
                } else {
                  navigate(`/experience/${localStorage.getItem("city")}`);
                }
              }}
            >
              Experiences
            </li>
            <li
              className="more-item mx-2"
              onClick={() => {
                hitGa("coroporate-booking");
                hitMoreGa("coroporate-booking");
                hitGaTag("more_buttons_click", "Bulk & Corporate Bookings");

                const currentPath = window.location.pathname;
                if (currentPath === "/bulkbooking/coroporate-booking") {
                  window.location.href = "/bulkbooking/coroporate-booking";
                } else {
                  navigate(`/bulkbooking/coroporate-booking`);
                }
              }}
            >
              Bulk & Corporate Bookings
            </li>
            <li
              className="more-item mx-2"
              onClick={() => {
                hitGa("oscar");
                hitMoreGa("oscar");
                hitGaTag("more_buttons_click", "Oscar");

                const currentPath = window.location.pathname;
                if (currentPath === "/oscar") {
                  window.location.href = "/oscar";
                } else {
                  navigate(`/oscar`);
                }
              }}
            >
              Oscar
            </li>
            <li
              className="more-item mx-2"
              onClick={() => {
                hitMoreGa("FAQ");
                hitGaTag("more_buttons_click", "FAQs");

                const currentPath = window.location.pathname;
                if (currentPath === "/faq") {
                  window.location.href = "/faq";
                } else {
                  navigate("/faq");
                }
              }}
            >
              FAQs
            </li>
            <li
              className="more-item mx-2"
              onClick={() => {
                hitMoreGa("Career");
                hitGa("career");
                hitGaTag("more_buttons_click", "Career")

                const currentPath = window.location.pathname;
                if (currentPath === "/careers-us") {
                  window.location.href = "/careers-us";
                } else {
                  navigate("/careers-us");
                }
              }}
            >
              Career
            </li>

            <li
              className="more-item mx-2"
              onClick={() => {
                hitGaTag("more_buttons_click", "News");
                const currentPath = window.location.pathname;
                if (currentPath === "/news") {
                  window.location.href = "/news";
                } else {
                  navigate("/news");
                }
              }}
            >
              News
            </li>
            <li
              className="more-item mx-2"
              onClick={() => {
                hitGaTag("more_buttons_click", "Investors Section");
                const currentPath = window.location.pathname;
                if (currentPath === "/investors-section") {
                  window.location.href = "/investors-section";
                } else {
                  navigate("/investors-section");
                }
              }}
            >
              Investors Section
            </li>
            <li
              className="more-item mx-2"
              onClick={() => {
                hitMoreGa("NVSP");
                hitGaTag("more_buttons_click", "NVSP");

                window.open(
                  theme === "inoxTheme"
                    ? "https://voters.eci.gov.in/"
                    : "https://voters.eci.gov.in/",
                  "_blank"
                );
              }}
            >
              NVSP
            </li>
            <li
              className="more-item mx-2"
              onClick={() => {
                hitMoreGa("NEST");
                hitGaTag("more_buttons_click", "NEST");

                window.open("https://pvrnest.godaddysites.com/home", "_blank");
              }}
            >
              NEST
            </li>
          </ul>
        </div>
      </>
    );
  };

  const filterUI = () => {
    return (
      <>
        <div className="filter-box">
          <div className="filter-head">
            <h3>Filters</h3>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="languages-filter">
                <div
                  className="languages-box"
                  onClick={() => {
                    setShowLanguage(!showLanguage);
                  }}
                >
                  <div className="languages-show">
                    <h2>Languages</h2>
                  </div>
                  <div className="languages-icon">
                    <img
                      src={showLanguage ? arrowUp : arrowDown}
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                </div>
                <div className={showLanguage ? "languages-perfer" : "d-none"}>
                  <ul>
                    {filterLanguage &&
                      filterLanguage.map((item, idx) => (
                        <li
                          className={
                            !selectedLanguageIds.some((x) => x === item)
                              ? ""
                              : theme === "inoxTheme"
                                ? "active-languages-inox"
                                : "active-languages-pvr"
                          }
                          key={idx}
                          onClick={() => {
                            findActiveLanguageFilter(item);
                          }}
                        >
                          {item}
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-sm-12">
              <div className="languages-filter">
                <div
                  className="languages-box"
                  onClick={() => {
                    setShowGenre(!showGenre);
                  }}
                >
                  <div className="languages-show">
                    <h2>Genre</h2>
                  </div>
                  <div className="languages-icon">
                    <img
                      src={showLanguage ? arrowUp : arrowDown}
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                </div>
                <div className={showGenre ? "languages-perfer" : "d-none"}>
                  <ul>
                    {filterGeners &&
                      filterGeners.map((item, idx) => (
                        <li
                          className={
                            !selectedGenreIds.some((x) => x === item)
                              ? ""
                              : theme === "inoxTheme"
                                ? "active-languages-inox"
                                : "active-languages-pvr"
                          }
                          key={idx}
                          onClick={() => findActiveGenreFilter(item)}
                        >
                          {item}
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
            {viewMode === 0 ? (
              <div className="col-sm-12">
                <div className="languages-filter">
                  <div
                    className="languages-box"
                    onClick={() => {
                      setShowAccessiblity(!showAccessiblity);
                    }}
                  >
                    <div className="languages-show">
                      <h2>Accessibility</h2>
                    </div>
                    <div className="languages-icon">
                      <img
                        src={showLanguage ? arrowUp : arrowDown}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                  </div>
                  <div
                    className={showAccessiblity ? "languages-perfer" : "d-none"}
                  >
                    <ul>
                      {accessiblityList.map((item, idx) => (
                        <li
                          className={
                            !selectedAccessiblityId
                              ? ""
                              : theme === "inoxTheme"
                                ? "active-languages-inox"
                                : "active-languages-pvr"
                          }
                          key={idx}
                          onClick={() => findActiveAccessiblityFilter(item)}
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          {totalMovieCount !== '' && totalMovieCount !== null && totalMovieCount !== undefined && (
            <div className="languages-filter text-center p-3">
              <span className="fw-bold" style={{ color: "#000" }}> Movie Count: {totalMovieCount} </span>
            </div>
          )}
          <div className="apply-filter">
            <div className="reset">
              <LightButton
                className="reset-btn"
                onClick={() => {
                  dispatch(
                    setMobileFilterValues({
                      lng: [],
                      grs: [],
                      accsblity: false,
                      status: 0,
                    })
                  );
                  setSelectedLanguageIds([]);
                  setSelectedGenreIds([]);
                  setSelectedAccessiblityId(false);
                  setTotalMovieCount('');
                  setVisibleBottom(false);
                }}
              >
                Reset
              </LightButton>
            </div>
            <div className="Filter">
              <DarkButton
                className="apply-filters"
                onClick={() => {
                  dispatch(
                    setMobileFilterValues({
                      lng: [...selectedLanguageIds],
                      grs: [...selectedGenreIds],
                      accsblity: selectedAccessiblityId,
                      status: countForSearch + 1,
                    })
                  );
                  setVisibleBottom(false);
                }}
              >
                Apply Filter
              </DarkButton>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <LoginPopup
        isOpen={isLoginPopupOpen}
        onClose={() => setIsLoginPopupOpen(false)}
      />
      {spalshData ? (
        <div className="footer-tab-mobile">
          <div className="app-view-footer">
            <div
              className={
                viewMode === 0 && theme === "pvrTheme"
                  ? "home-icon home-icon-pvr-active"
                  : viewMode === 0 && theme === "inoxTheme"
                    ? "home-icon home-icon-inox-active"
                    : "home-icon"
              }
              onClick={() => {
                navigate("/");
                setViewMode(0);
                hitGaTags("bottom_navi_click", "Home");
              }}
            >
              <div className="icon-img">
                <img
                  src={viewMode === 0 ? homeActiveIcon : homeIcon}
                  alt=""
                  className="img-fluid"
                />
              </div>
              <p>Home</p>
            </div>
            <div
              className={
                viewMode === 1 && theme === "pvrTheme"
                  ? "home-icon home-icon-pvr-active"
                  : viewMode === 1 && theme === "inoxTheme"
                    ? "home-icon home-icon-inox-active"
                    : "home-icon"
              }
              onClick={() => {
                setViewMode(1);
                hitGa("top_navi_cinemas");
                hitGa("cinemas_click");
                hitGaTags("bottom_navi_click", "Cinemas");

                navigate(`/cinemas/${localStorage.getItem("city")}`);
              }}
            >
              <div className="icon-img">
                <img
                  src={
                    viewMode === 1 && theme === "inoxTheme"
                      ? cinemaInoxActiveIcon
                      : viewMode === 1 && theme === "pvrTheme"
                        ? cinemaPvrActiveIcon
                        : cinemIcon
                  }
                  alt=""

                  className="img-fluid"
                />
              </div>
              <p>Cinemas</p>
            </div>
            <div
              className={
                currentPath === "/offers"
                  ? theme === "pvrTheme"
                    ? "home-icon home-icon-pvr-active"
                    : "home-icon home-icon-inox-active"
                  : "home-icon"
              }
              onClick={() => {
                if (spalshData?.passport == "true") {
                  hitGaTags("bottom_navi_click", "Passport");
                  window.open("https://passport.pvrinox.com/", "_blank")?.focus();
                } else {
                  hitGaTags("bottom_navi_click", "Offers");
                  setViewMode(2);
                  hitGa("top_navi_offers");
                  const currentPath = window.location.pathname;
                  if (currentPath === "/offers") {
                    window.location.href = "/offers";
                  } else {
                    navigate("/offers");
                  }
                }
              }}
            >

              <div className="icon-img">
                <img
                  src={
                    spalshData?.passport == "true"
                      ? passportIcon
                      : viewMode === 2
                        ? passportActiveIcon
                        : OfferStroke
                  }
                  alt=""
                  className="img-fluid"
                />
              </div>
              <p>{spalshData?.passport == "true" ? "Passport" : "Offer"}</p>
            </div>
            <div
              className={
                viewMode === 3 && theme === "pvrTheme"
                  ? "home-icon home-icon-pvr-active"
                  : viewMode === 3 && theme === "inoxTheme"
                    ? "home-icon home-icon-inox-active"
                    : "home-icon"
              }
              onClick={() => {
                setViewMode(3);
                hitGa("coming_soon_click");
                hitGaTags("bottom_navi_click", "Coming Soon");

                navigate("/coming-soon");
              }}
            >
              <div className="icon-img">
                <img
                  src={viewMode === 3 ? comingSoonActiveIcon : comingSoonIcon}
                  alt=""
                  className="img-fluid"
                />
              </div>
              <p>Coming Soon</p>
            </div>
            <div
              className="home-icon"
              onClick={() => {
                setVisibleBottom(true);
                // hitGa("top_navi_more_click")
                hitGaTags("bottom_navi_click", "More");

                setFilterUIViewMode(0);
              }}
            >
              <div className="icon-img">
                <img src={moreIcon} alt="" className="img-fluid" />
              </div>
              <p>More</p>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      {viewMode === 3 || viewMode === 9 ? (
        <>
          <div
            className="filter-mobile"
            style={{
              backgroundColor: theme === "inoxTheme" ? "#234B9E" : "#FFCB05",
            }}
            onClick={() => {
              setVisibleBottom(true);
              setFilterUIViewMode(1);
            }}
          >
            <img
              src={theme === "inoxTheme" ? filterM : FilterBlack}
              alt=""
              className="img-fluid"
            />
            {filterDataVal?.accsblity === true ||
              filterDataVal?.lng.length > 0 ||
              filterDataVal?.grs.length > 0 ? (
              <div className="circle-tab"></div>
            ) : (
              ""
            )}
          </div>
          {/* {viewMode === 0 ? (
            <div
              className="filter-mobile"
              style={{
                backgroundColor: theme === "inoxTheme" ? "#234B9E" : "#FFCB05",
                bottom: "120px",
              }}
              onClick={() => {
                // setVisibleBottom(true);
                // setFilterUIViewMode(1);
                navigate("/insta-food");
              }}
            >
              <img src={FNBICON} alt="" className="img-fluid" />
            </div>
          ) : (
            ""
          )} */}
        </>
      ) : (
        ""
      )}
      <div>
        <Sidebar
          visible={visibleBottom}
          onHide={() => {
            setVisibleBottom(false);
            if (filterDataVal?.status === 0) {
              setSelectedLanguageIds([]);
              setSelectedGenreIds([]);
              setTotalMovieCount('');
            } else {
              setSelectedLanguageIds([...filterDataVal?.lng]);
              setSelectedGenreIds([...filterDataVal?.grs]);
              setSelectedAccessiblityId(filterDataVal?.accsblity);
            }
          }}
          position="bottom"
          className="mobile-filter-app"
          dismissable={true}
          showCloseIcon={false}
          blockScroll={true}
        >
          <>{filterUIViewMode === 0 ? moreUI() : filterUI()}</>
        </Sidebar>
      </div>
      <div className="">
        <Dialog
          header=""
          visible={loginVewMode}
          showHeader={false}
          showCloseIcon={false}
          onHide={() => dispatch(setLoginViewMode({ value: false }))}
          className="register-mobile"
          blockScroll={true}
        >
          <div className="row">
            <Login />
          </div>
        </Dialog>
      </div>
      <div style={{ display: "none" }}>
        <MoreDropdown />
      </div>
    </>
  );
};

export default MobileFooter;
